<template>
  <el-card
    v-loading="loading"
    shadow="never">
    <el-form
      :model="form"
      :rules="rules"
      class="el-form-width"
      ref="form"
      label-width="100px"
    >
      <el-form-item
        prop="serviceName"
        label="服务名称"
      >
        <el-input type="text" v-model="form.serviceName" placeholder="请填写服务名称"></el-input>
      </el-form-item>
      <el-upload
        class="avatar-uploader"
        :action="appApi"
        accept="image"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <span v-if="!imageUrl" class="avatar-uploader-icon">点击上传图片</span>
      </el-upload>
      <el-form-item
        class="customizeCss"
        prop="seqNum"
        label="排序号"
      >
        <el-input type="text" v-model="form.seqNum" placeholder="排序号"></el-input>
      </el-form-item>

      <el-form-item
        prop="serviceTypeId"
        label="服务类型"
      >
        <el-select v-model="form.serviceTypeId" clearable placeholder="请选择服务类型">
          <el-option
            v-for="item in serviceTypeOption"
            :key="item.serviceTypeId"
            :label="item.name"
            :value="item.serviceTypeId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="price"
        label="服务单价"
      >
        <el-input type="number" v-model="form.price" placeholder="请填写服务单价"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12"><el-form-item
          prop="priceRemark"
          class="ipt-textarea"
          label="收费规则"
        >
          <el-input type="textarea" v-model="form.priceRemark" placeholder="请填写收费规则"></el-input>
        </el-form-item></el-col>
        <el-col :span="12"><el-form-item
          prop="useRange"
          label="适用范围"
          class="ipt-textarea"
        >
          <el-input type="textarea" v-model="form.useRange" placeholder="请填写服务范围注" resize="none"></el-input>
        </el-form-item></el-col>
      </el-row>

      <el-form-item label="服务详情：" prop="serviceContent">
        <quill-editor v-loading="loading"
                      class="content-des"
                      v-model="form.serviceContent"
                      ref="basicQuillEditor"
                      :options="editorOption">
        </quill-editor>
        <el-upload
          class="avatar-uploader"
          id="basic-uploader"
          :action="appApi"
          accept="image"
          :show-file-list="false"
          :on-success="uploadSuccess1"
          :on-error="uploadError"
          :before-upload="beforeUpload">
        </el-upload>
      </el-form-item>
      <div class="tc">
        <el-button
          style="width: 140px"
          @click="goBack">返回
        </el-button>
        <el-button
          style="width: 140px"
          type="primary"
          @click="onSubmit">保存
        </el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import {serve} from '../../api'
import {quillEditor} from 'vue-quill-editor'
import {validImage, toolbarOptions, quillUploadSuccess} from '@/utils'
import {getSession} from '../../utils/session'
import {ORG_CODE, USER_ID} from '../../constants'
export default {
  name: 'SeveForm',
  props: {
    serviceId: String
  },
  mounted () {
    if (this.serviceId) {
      this.getServiceDetail()
    }
    this.getServiceType()
  },
  data () {
    return {
      appApi: process.env.VUE_APP_API + '/upload/image/single/',
      editorOption: {
        placeholder: '请填写服务详情',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              'image': function (value) {
                if (value) document.querySelector('#basic-uploader input').click()
              }
            }
          }
        }},
      loading: false,
      submitting: false,
      dialogFormVisible: false,
      serviceTypeOption: [],
      imageUrl: '',
      form: {
        serviceId: '',
        orgCode: getSession(ORG_CODE),
        serviceTypeId: this.$route.params.serviceTypeId,
        serviceName: '',
        serviceLogo: '',
        price: '',
        onFlag: true,
        priceRemark: '',
        useRange: '',
        serviceContent: '',
        seqNum: '',
        createUser: getSession(USER_ID),
        remark: ''
      },
      rules: {
        serviceName: [
          {required: true, message: '请填写服务名称', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'}
        ],
        serviceTypeId: [
          {required: true, message: '请选择服务类型', trigger: 'blur'}
        ],
        price: [
          {required: true, message: '请填写服务单价', trigger: 'blur'}
        ],
        seqNum: [
          {required: true, message: '请填写排序号', trigger: 'blur'}
        ],
        priceRemark: [
          {required: true, message: '请填写收费规则', trigger: 'blur'},
          {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
        ],
        useRange: [
          {required: true, message: '请填写适用范围', trigger: 'blur'},
          {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
        ],

        serviceContent: [
          {required: true, message: '请填写服务详情', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    async getServiceType () {
      let {data} = await serve.listServeType({param: {onFlag: true, orgCode: getSession(ORG_CODE)}})
      this.serviceTypeOption = data
    },
    async getServiceDetail () {
      this.loading = true
      let {data} = await serve.getServeDetail(this.serviceId)
      this.loading = false
      if (data.serviceLogo) {
        this.imageUrl = process.env.VUE_APP_IMG + data.serviceLogo
      }
      delete data.createTime
      this.form = data
    },
    async goBack () {
      this.$closeCurrentView()
      this.$router.back()
    },
    async onSubmit () {
      await this.$refs.form.validate()
      if (!this.form.serviceLogo) {
        this.$message({
          type: 'error',
          message: '请上传服务图片'
        })
        return
      }
      this.submitting = true
      if (this.form.serviceId) {
        let {code, data} = await serve.updateServe({
          ...this.form
        })
        this.submitting = false
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '服务修改成功'
          })
          this.$bus.$emit('updateServeList')
          this.$closeCurrentView()
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: '服务修改失败'
          })
        }
      } else {
        let {code, data} = await serve.addServe(this.form)
        this.submitting = false
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '服务添加成功'
          })
          this.$bus.$emit('updateServeList')
          this.$closeCurrentView()
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: '服务添加失败'
          })
        }
      }
    },
    uploadSuccess (res, file) {
      this.loading = false
      this.imageUrl = process.env.VUE_APP_IMG + res.data
      this.form.serviceLogo = res.data
    },
    uploadError () {
      this.loading = false
      this.$message({type: 'info', message: '插入图片失败，请稍后重试'})
    },
    beforeUpload (file) {
      let validImage1 = validImage(file, 500)
      this.loading = validImage1
      return validImage1
    },
    // 上传图片成功
    uploadSuccess1 (res) {
      this.loading = false
      let quill = this.$refs.basicQuillEditor.quill
      quillUploadSuccess(res, quill)
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-form-width {
    width: 800px;
  }
  .el-card {
    border: none;
    /deep/ .el-card__body {
      padding-top: 30px;
      .el-form {
        &.el-form--inline {
          width: 745px;
        }
        .el-form-item__content,
        .el-date-editor.el-input,
        .el-input--suffix {
          width: 300px;
        }
        .ipt-textarea {
          display: block;
          .el-form-item__content {
            width: 300px;
          }
        }
      }
      .el-upload,
      .el-upload--text {
        margin-left: 550px;
        margin-top: -58px;
      }
      .customizeCss {
        margin-top: -125px;
      }
    }
  }

  .el-input__icon {
    margin-right: 8px;
  }
  .content-des {
    height: 300px;
    width: 700px;
    border-color: #dfe1e7;
  }

</style>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    display: block;
    font-size: 14px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
